var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel wraper panel-gray" },
    [
      _c("div", { staticClass: "panel-header" }, [
        _c("div", { staticClass: "panel-title" }, [_vm._m(0)], 1)
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-body", attrs: { id: "formbody" } },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.$v.tempPerson.name.$error,
                "error-label": _vm._f("errorLabel")(_vm.$v.tempPerson.name)
              }
            },
            [
              _c("q-input", {
                attrs: { autofocus: true, "float-label": "ФИО" },
                model: {
                  value: _vm.tempPerson.name,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempPerson,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempPerson.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { "float-label": "Должность" },
                model: {
                  value: _vm.tempPerson.appointment,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempPerson,
                      "appointment",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempPerson.appointment"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { type: "textarea", rows: 1, "float-label": "Контакты" },
                model: {
                  value: _vm.telString,
                  callback: function($$v) {
                    _vm.telString = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "telString"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { type: "textarea", rows: 1, "float-label": "Заметки" },
                model: {
                  value: _vm.tempPerson.comment,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempPerson,
                      "comment",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempPerson.comment"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("save-btn", {
        attrs: {
          notChanged: _vm.notChanged,
          goView: _vm.goView,
          doSave: _vm.doSave
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("unit-path", {
      attrs: { id: _vm.iniPerson.parent_id, lbl: _vm.lbl }
    })
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-151aae7c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-151aae7c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/person-edit.vue
// module id = null
// module chunks = 